import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

// Import Lucide icons
import {
  Edit3,
  Trash2,
  Plus,
  Calendar,
  User,
  Clock,
  Video,
  Globe,
  Eye,
  X,
  PlayCircle,
  CalendarDays,
  Users,
  Filter,
  Search,
  Download,
  ChevronRight,
  AlertCircle,
  Edit,
} from "lucide-react";

import { useSelector } from "react-redux";
import api from "../../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "../loader";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { AddLiveSession } from "./AddLiveSession";
import { EditSessionLink } from "./EditSession";
import "./Live.css";

function AdminLiveSession({ match }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };

  const getVideo = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const postData = await api.liveSessionGetAdmin(payload);
      console.log(postData);
      setData(postData.sessions || []);
      setFilteredData(postData.sessions || []);
      setnoOfPost(postData.count);
      setLimit(postData.limit);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const deleteBroadcast = async (id) => {
    try {
      let payload = {
        id: id,
      };
      setLoader(true);
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this session?",
      );
      if (isConfirmed) {
        const liveSession = await api.liveSessionDelete(payload);
        console.log("deleted");
        getVideo();
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const endLiveChat = async (id) => {
    try {
      let payload = {
        sessionId: id,
      };
      setLoader(true);
      const isConfirmed = window.confirm(
        "Are you sure you want to close chat?",
      );
      if (isConfirmed) {
        const liveSession = await api.endLiveChat(payload);
        console.log("deleted");
        getVideo();
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    if (value === "") {
      setFilteredData(data);
    } else {
      const filtered = data.filter(
        (item) =>
          item?.title?.toLowerCase().includes(value) ||
          item?.createdBy?.email?.toLowerCase().includes(value),
      );
      setFilteredData(filtered);
    }
  };

  useEffect(() => {
    getVideo();
  }, [page]);

  return (
    <>
      <div className="admin-live-sessions-container">
        {/* Header Section */}
        <div className="sessions-header">
          <div className="content-header">
            <div className="header-left">
              <div className="header-icon-wrapper">
                <Video size={50} className="header-icon" />
              </div>
              <div className="header-title-wrapper">
                <h1 className="header-title">Live Sessions</h1>
                <span className="sessions-count">{noOfPost} sessions</span>
              </div>
            </div>
            <div className="header-right">
              <div className="search-box">
                <Search size={20} className="icon-search" />
                <input
                  type="text"
                  placeholder="Search sessions..."
                  value={searchTerm}
                  onChange={handleSearch}
                  className="search-input"
                />
              </div>
              <button className="add-session-btn" onClick={handleShow}>
                <Plus size={18} />
                <span>Add Session</span>
              </button>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="stats-container">
          <div className="stat-card">
            <div className="stat-icon total">
              <Video size={24} />
            </div>
            <div className="stat-content">
              <span className="stat-value">{noOfPost}</span>
              <span className="label-stat">Total Sessions</span>
            </div>
          </div>
          {/* <div className="stat-card">
            <div className="stat-icon upcoming">
              <Clock size={24} />
            </div>
            <div className="stat-content">
              <span className="stat-value">
                {
                  data.filter((item) => new Date(item.eventTime) > new Date())
                    .length
                }
              </span>
              <span className="label-stat">Upcoming</span>
            </div>
          </div> */}
          <div className="stat-card">
            <div className="stat-icon recent">
              <Calendar size={24} />
            </div>
            <div className="stat-content">
              <span className="stat-value">
                {data.length > 0
                  ? moment(data[0]?.createdAt).format("MMM D")
                  : "-"}
              </span>
              <span className="label-stat">Last Added</span>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="table-section">
          <div className="section-header">
            <h3 className="section-title">
              <PlayCircle size={20} />
              Session Library
            </h3>
            <div className="section-actions">
              <span className="filter-count">
                Showing {filteredData.length} of {noOfPost} sessions
              </span>
            </div>
          </div>
          <div className="table-container">
            <Table
              data={filteredData}
              setPage={setPage}
              page={page}
              noOfPost={noOfPost}
              limit={limit}
              deleteBroadcast={deleteBroadcast}
              handleShowEdit={handleShowEdit}
              isEmpty={filteredData.length === 0}
              searchTerm={searchTerm}
              endLiveChat={endLiveChat}
            />
          </div>
        </div>
      </div>

      {loader && <Loader />}

      {/* Add Session Modal */}
      <Modal
        show={show}
        size="lg"
        onHide={handleClose}
        centered
        className="modern-modal"
      >
        <Modal.Body>
          <div className="modal-content-wrapper">
            <div className="modal-header">
              <div className="modal-title-wrapper">
                <h2 className="modal-title">Schedule Live Session</h2>
                <p className="modal-subtitle">
                  Create a new live streaming session
                </p>
              </div>
              <button className="close-modal-btn" onClick={handleClose}>
                <X size={24} />
              </button>
            </div>
            <div className="modal-body-content">
              <AddLiveSession
                getVideo={getVideo}
                setShow={setShow}
                videoData={selectedData}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Edit Session Modal */}
      <Modal
        show={showEdit}
        size="lg"
        onHide={handleCloseEdit}
        centered
        className="modern-modal"
      >
        <Modal.Body>
          <div className="modal-content-wrapper">
            <div className="modal-header">
              <div className="modal-title-wrapper">
                <h2 className="modal-title">Edit Live Session</h2>
                <p className="modal-subtitle">Update session details</p>
              </div>
              <button className="close-modal-btn" onClick={handleCloseEdit}>
                <X size={24} />
              </button>
            </div>
            <div className="modal-body-content">
              <EditSessionLink
                getVideo={getVideo}
                setShow={setShowEdit}
                videoData={selectedData}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

const Table = ({
  data,
  page,
  setPage,
  noOfPost,
  limit,
  deleteBroadcast,
  handleShowEdit,
  isEmpty,
  searchTerm,
  endLiveChat,
}) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let date1 = new Date(date);
    let dateTemp = moment(date1).format("MMM Do YYYY, h:mm A");
    return dateTemp;
  };

  const formatEventTime = (date) => {
    let date1 = new Date(date);
    let now = new Date();
    let isUpcoming = date1 > now;

    return {
      date: moment(date1).format("MMM Do YYYY"),
      time: moment(date1).format("h:mm A"),
      status: isUpcoming ? "upcoming" : "past",
    };
  };

  return (
    <>
      <div className="modern-table-wrapper">
        <div className="table-responsive">
          <table className="modern-table">
            <thead>
              <tr>
                <th className="table-header">
                  <div className="header-cell">
                    <Video size={16} />
                    <span>Title</span>
                  </div>
                </th>
                <th className="table-header">
                  <div className="header-cell">
                    <Globe size={16} />
                    <span>Session</span>
                  </div>
                </th>
                <th className="table-header">
                  <div className="header-cell">
                    <Calendar size={16} />
                    <span>Event Time</span>
                  </div>
                </th>
                <th className="table-header">
                  <div className="header-cell">
                    <User size={16} />
                    <span>Created By</span>
                  </div>
                </th>
                <th className="table-header">
                  <div className="header-cell">
                    <Clock size={16} />
                    <span>Created At</span>
                  </div>
                </th>
                <th className="table-header">
                  <div className="header-cell">
                    <span>Actions</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {isEmpty ? (
                <tr className="empty-table-row">
                  <td colSpan="6">
                    <div className="empty-state">
                      <div className="empty-icon">
                        <Video size={48} />
                      </div>
                      <h3 className="empty-title">
                        {searchTerm
                          ? "No matching sessions found"
                          : "No live sessions yet"}
                      </h3>
                      <p className="empty-description">
                        {searchTerm
                          ? "Try adjusting your search terms"
                          : "Schedule your first live session to get started"}
                      </p>
                    </div>
                  </td>
                </tr>
              ) : (
                data.map((item, key) => {
                  const eventTime = formatEventTime(item?.eventTime);

                  return (
                    <tr key={key} className="table-row">
                      <td className="table-cell">
                        <div className="cell-content">
                          <span className="cell-text title">
                            {item?.title || "-"}
                          </span>
                        </div>
                      </td>
                      <td className="table-cell">
                        <div className="session-link-wrapper">
                          {item?.link ? (
                            <a
                              href={
                                item.link.includes("http")
                                  ? item.link
                                  : `https://${item.link}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              className="session-link"
                            >
                              <PlayCircle size={14} />
                              <span>Join Session</span>
                            </a>
                          ) : (
                            <span className="no-link">No link</span>
                          )}
                        </div>
                      </td>
                      <td className="table-cell">
                        <div className="event-time-cell">
                          <div className="event-date">{eventTime.date}</div>
                          <div className="event-time">{eventTime.time}</div>
                          {eventTime.status === "upcoming" ? (
                            <div className="event-status upcoming">Upcoming</div>
                          ) : item?.isEnded ? (
                            <div className="event-status past">Completed</div>
                          ) : (
                            <div className="event-status" style={{ background: "#fff3cd", color: "#856404", borderRadius: 4, padding: "2px 8px", fontSize: 11, fontWeight: 600, display: "inline-block" }}>Ongoing</div>
                          )}
                        </div>
                      </td>
                      <td className="table-cell">
                        <div className="cell-content">
                          <User size={16} className="cell-icon" />
                          <span className="cell-text">
                            {item?.createdBy?.email || "-"}
                          </span>
                        </div>
                      </td>
                      <td className="table-cell">
                        <div className="cell-content">
                          <Calendar size={16} className="cell-icon" />
                          <span className="cell-text">
                            {formatDate(item?.createdAt)}
                          </span>
                        </div>
                      </td>
                      <td className="table-cell">
                        <div className="action-buttons">
                          {item?.isEnded ? (
                            <button className="status-indicator offline-status">
                              Chat Closed
                            </button>
                          ) : (
                            <button
                              className="session-link"
                              onClick={() => endLiveChat(item._id)}
                            >
                              Close Chat
                            </button>
                          )}
                          <button
                            className="action-btn view-btn"
                            onClick={() => window.open(item.link, "_blank")}
                            title="View Session"
                            disabled={!item?.link}
                          >
                            <Eye size={18} />
                          </button>
                          <button
                            className="action-btn view-btn"
                            onClick={() => handleShowEdit(item)}
                            title="Edit"
                          >
                            <Edit size={18} />
                          </button>
                          <button
                            className="action-btn delete-btn"
                            onClick={() => deleteBroadcast(item?._id)}
                            title="Delete"
                          >
                            <Trash2 size={18} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination - Show only when there's data */}
        {!isEmpty && data.length > 0 && (
          <div className="pagination-container">
            <div className="pagination-info">
              Showing {(page - 1) * limit + 1} -{" "}
              {Math.min(page * limit, noOfPost)} of {noOfPost} sessions
            </div>
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfPost / limit)}
                page={page}
                onChange={handleChange}
                shape="rounded"
                color="primary"
                size="large"
                sx={{
                  "& .MuiPaginationItem-root": {
                    fontSize: "14px",
                    fontWeight: 500,
                  },
                  "& .Mui-selected": {
                    background:
                      "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%) !important",
                    color: "white",
                  },
                }}
              />
            </Stack>
          </div>
        )}
      </div>
    </>
  );
};

export default AdminLiveSession;
